module.exports = __webpack_public_path__ + "static/media/wisepim.7c41b885.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/wisepim.webp
// module id = 907
// module chunks = 0